import { createFileRoute } from "@tanstack/react-router";
import { FeedContainer } from "../../app/views/feedContainer";

export const Route = createFileRoute("/feed")({
  component: FeedContainer,
});
